import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';
import { SweetAlertService } from '../../../../services/sweet-alert/sweet-alert.service';
import { fuseAnimations } from '../../../../../core/animations';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { TranslationService } from '../../../../services/translation/translation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurriculumDataSource } from './CurriculumDataSource';
import { CurriculumDatabase } from './curriculumDatabase';
import { CurriculumService } from '../../../../services/curricula/curriculum.service';
import { Curriculum } from '../../../../models/curricula/curriculum';

@Component({
    selector: 'fuse-management-curriculum',
    templateUrl: './curriculum.component.html',
    styleUrls: ['./curriculum.component.scss'],
    animations: fuseAnimations
})
export class CurriculumComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUI: NgBlockUI;
    displayedColumns = ['Description', 'Actions'];
    curriculumDatabase: CurriculumDatabase;
    dataSource: CurriculumDataSource | null;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('filter') filter: ElementRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private authenticationService: AuthenticationService,
        public dialog: MatDialog,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private curriculumService: CurriculumService,
        private route: ActivatedRoute,
        private router: Router,
    ) {
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        this.curriculumDatabase = new CurriculumDatabase(this.curriculumService);
        this.dataSource = new CurriculumDataSource(this.curriculumDatabase, this.paginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        this.blockUI.stop();
    }

    ngOnDestroy() {

    }

    add() {
        this.router.navigate(['pages/management/curriculum/add']);
    }

    edit(curriculum: any) {
        this.router.navigate(['pages/management/curriculum/edit/' + curriculum.Id]);
    }

    view(curriculum: any) {
        this.router.navigate(['pages/management/curriculum/view/' + curriculum.Id]);
    }

    delete(curriculum: Curriculum) {
        this.translationService.translate('LABELS.DELETION_CONFIRMATION_QUESTION', curriculum.Description, (res) => {
            this.sweetAlertService.question(this.translationService.confirmation, res, this.translationService.yes, this.translationService.no, () => {
                this.curriculumService.delete(curriculum.Id).subscribe(response => {
                    if (response.ResultCode === 1) {
                        this.curriculumDatabase.delete(curriculum);
                        const index = this.curriculumService.curricula.findIndex(s => s.Id === curriculum.Id);
                        if (index >= 0) {
                            this.curriculumService.curricula.splice(index, 1);
                            delete this.curriculumService.curriculumObject[curriculum.Id];
                        }
                        this.sweetAlertService.success(this.translationService.success, this.translationService.deletedCorrectly, null);
                    } else {
                        this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                            this.sweetAlertService.error('Error', res, null);
                        });
                    }
                }, error => {
                    this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                        this.sweetAlertService.error('Error', res, null);
                    });
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/curricula/curriculum.component.ts